import {Box, Typography} from '@mui/material';
import {ReactNode} from 'react';
import {neutral, semantic, brand} from 'src/theme';

export interface SummaryStatItem {
  label: string;
  value: number | string;
  color?: 'default' | 'success' | 'error' | 'primary' | 'info';
  icon?: ReactNode;
}

interface SummaryBarProps {
  stats: SummaryStatItem[];
}

const colorMap: Record<string, string> = {
  default: neutral[500],
  success: semantic.success.main,
  error: semantic.error.main,
  primary: brand[500],
  info: brand[500],
};

export default function SummaryBar({stats}: SummaryBarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: {xs: 2, md: 3},
        bgcolor: neutral[25],
        border: `1px solid ${neutral[200]}`,
        borderRadius: 1,
        px: 3,
        py: 1.5,
        flexWrap: 'wrap',
      }}
    >
      {stats.map((stat, idx) => (
        <Box
          key={idx}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
          }}
        >
          {stat.icon && (
            <Box sx={{display: 'flex', color: colorMap[stat.color || 'default']}}>
              {stat.icon}
            </Box>
          )}
          <Typography
            variant="body2"
            sx={{color: neutral[500], fontWeight: 500, whiteSpace: 'nowrap'}}
          >
            {stat.label}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              color: colorMap[stat.color || 'default'],
              whiteSpace: 'nowrap',
            }}
          >
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
